export const juneSoScriptSrc = "https://unpkg.com/@june-so/analytics-next/dist/umd/standalone.js";
